var _defs, _path, _path2, _path3, _rect, _path4, _path5, _path6, _rect2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkingWithLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 675.68 597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 316.23,
    x2: 303.73,
    y1: 161.79,
    y2: 163.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#edcbd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 5489.66,
    x2: 5477.15,
    y1: 161.79,
    y2: 163.86,
    gradientTransform: "matrix(-1 0 0 1 5955.09 0)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 340.05,
    x2: 342.05,
    y1: 534.48,
    y2: 743.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0d0d12",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2f2e40",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f3d56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 377.47,
    x2: 392.87,
    y1: 312.77,
    y2: -23.57,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 199.41,
    x2: 563.94,
    y1: 499.55,
    y2: 499.55,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 387.17,
    x2: 390.91,
    y1: 581.54,
    y2: 513.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69b9eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 381.57,
    x2: 382.14,
    y1: 528.68,
    y2: 395.54,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 498.79,
    x2: 75.38,
    y1: 483.91,
    y2: 637.05,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 384.14,
    x2: 395.38,
    y1: 240.43,
    y2: 548.08,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 163.66,
    x2: 188.03,
    y1: 615.27,
    y2: 208.03,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 590.73,
    x2: 617.87,
    y1: 713.7,
    y2: 260.18,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 385.46,
    x2: 398.21,
    y1: 318.79,
    y2: 105.65,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 391.3,
    x2: 387.82,
    y1: 5.43,
    y2: 348.28,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 409.14,
    x2: 311.43,
    y1: 342.81,
    y2: 1053.08,
    xlinkHref: "#b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M433.93,59.35C396.8,81.2,354.8,93,313.44,105.12S230.24,130,194.11,153.47s-66.41,59.3-73.45,101.81c-2.59,15.68-2,31.91-6.5,47.16-8.75,29.71-35.08,50.93-48,79.05C48.19,420.39,58.86,467.91,83.46,503c32.25,45.94,85.51,73.91,140.39,85.72s111.78,9,167.68,3.88C454,586.8,517.16,577.9,574.78,553s109.8-67.61,134.31-125.38c16.11-38,27.17-80.59,20.38-121.27C676.63-10.32,457.47,45.51,433.93,59.35Z",
    opacity: 0.18,
    transform: "translate(-57.17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M309.84,147.37a6.42,6.42,0,0,0-5.1,2.13,7.86,7.86,0,0,0-1.44,3.67,22.72,22.72,0,0,0,8.12,21.34c2.07,1.63,4.66,2.93,7.26,2.48a1.36,1.36,0,0,0,.8-.35,1.54,1.54,0,0,0,.29-1.06c.21-7,.38-14.16-2.31-20.58C315.58,150.53,315.44,147.44,309.84,147.37Z",
    transform: "translate(-57.17)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M471.82,147.37a6.44,6.44,0,0,1,5.11,2.13,8,8,0,0,1,1.43,3.67,22.71,22.71,0,0,1-8.11,21.34c-2.07,1.63-4.67,2.93-7.27,2.48a1.39,1.39,0,0,1-.8-.35,1.59,1.59,0,0,1-.29-1.06c-.21-7-.37-14.16,2.32-20.58C466.08,150.53,466.22,147.44,471.82,147.37Z",
    transform: "translate(-57.17)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 658.72,
    height: 103.55,
    x: 10.79,
    y: 493.17,
    fill: "#68e1fd",
    rx: 32.74
  })), /*#__PURE__*/React.createElement("rect", {
    width: 658.72,
    height: 103.55,
    x: 10.79,
    y: 493.17,
    fill: "url(#b)",
    rx: 32.74,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M321.18,214.77s-77-4.51-110.66,36.59-16.11,234.83-16.11,234.83l355.72,8.1,14.48-219.18c1.43-46.23-54.05-60.55-112.56-60.36l-3.06,0C346,215.8,321.18,214.77,321.18,214.77Z",
    transform: "translate(-57.17)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M321.18,214.77s-77-4.51-110.66,36.59-16.11,234.83-16.11,234.83l355.72,8.1,14.48-219.18c1.43-46.23-54.05-60.55-112.56-60.36l-3.06,0C346,215.8,321.18,214.77,321.18,214.77Z",
    transform: "translate(-57.17)",
    style: {
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M259.38 223.93s-63.36 0-123.9 157.77l77.66 35.24 39.16-48.78zM518.48 223.93s63.36 0 123.9 157.77l-77.66 35.24-39.16-48.78z",
    transform: "translate(-57.17)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M173,385.14a14,14,0,0,1-6.66-19c15.92-31.71,64.67-106,97.76-110.38,41.45-5.51,88.7-11.28,88.7-11.28s143.58-2.62,167.43,14c18.67,13,61,68.48,84.06,99.27,5.33,7.13,3.34,20.21-4.74,24l-57,46.21a14.13,14.13,0,0,0-4.85,3.72l-38.25,45.72a14,14,0,0,1-11.45,5l-200.87-9.91a14,14,0,0,1-12.51-9.25l-23.8-66.06a14,14,0,0,0-25.45-2.07h0A14,14,0,0,1,207.2,401Z",
    opacity: 0.24,
    transform: "translate(-57.17)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 658.72,
    height: 103.55,
    x: 16.96,
    y: 473.44,
    fill: "#68e1fd",
    rx: 32.74
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d2741",
    d: "M123.64,510.83c2.49,1.56,5.43,1.63,8.24,1.68l51.88.74a50.53,50.53,0,0,0-9.71,6.87c-11.5,10.34-4.59,29.4,10.87,29.93,117.45,4,235,2.61,352.48,1.22,18.34-.22,36.75-.44,55-2.31a15,15,0,0,0,10.65-23.75h0a6.63,6.63,0,0,1,5.44-9c19.18-2.23,39-1.52,58-4.77,3.75-.64,8.13-1.82,9.65-6,1-2.59.43-5.6-.39-8.25-3.85-12.33-13.86-20.78-24.45-24.56s-21.85-3.58-32.9-3.36L184.14,478c-15,.3-39.15-5-53.22,1.41C122.11,483.44,111.12,503,123.64,510.83Z",
    opacity: 0.18,
    transform: "translate(-57.17)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M216.13,527.12,200.58,484s-6.36-7.34,10.6-10.6,345.12,0,345.12,0l7.64,53.68Z",
    transform: "translate(-57.17)",
    style: {
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M563.94,527.12v4.44a13.38,13.38,0,0,1-13.38,13.38h-321a13.38,13.38,0,0,1-13.38-13.38v-4.44a13.35,13.35,0,0,1,13.38-13.39h321a13.35,13.35,0,0,1,13.38,13.39Z",
    transform: "translate(-57.17)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M563.38,523.25a13.4,13.4,0,0,1-12.82,9.51h-321a13.4,13.4,0,0,1-12.82-9.51,13.4,13.4,0,0,1,12.82-9.52h321A13.4,13.4,0,0,1,563.38,523.25Z",
    transform: "translate(-57.17)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M216.13,527.12,200.58,484s-6.36-7.34,10.6-10.6,345.12,0,345.12,0l7.64,53.68Z",
    transform: "translate(-57.17)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M563.38,523.25a13.4,13.4,0,0,1-12.82,9.51h-321a13.4,13.4,0,0,1-12.82-9.51,13.4,13.4,0,0,1,12.82-9.52l326.79-5.42C562.35,508.31,561.71,517.74,563.38,523.25Z",
    transform: "translate(-57.17)",
    style: {
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M556.3,309.22V494.29a19.44,19.44,0,0,1-19.44,19.44H243.21a19.42,19.42,0,0,1-19.44-19.44V309.22a19.44,19.44,0,0,1,19.44-19.44H536.86a19.42,19.42,0,0,1,19.44,19.44Z",
    transform: "translate(-57.17)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M556.3,309.22V494.29a19.44,19.44,0,0,1-19.44,19.44H243.21a19.42,19.42,0,0,1-19.44-19.44V309.22a19.44,19.44,0,0,1,19.44-19.44H536.86a19.42,19.42,0,0,1,19.44,19.44Z",
    transform: "translate(-57.17)",
    style: {
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M556.3,309.22V494.3a19.38,19.38,0,0,1-8.42,16,.91.91,0,0,1-.16.11,19.16,19.16,0,0,1-9.81,3.29c-.35,0-.69,0-1.06,0H243.2a19.33,19.33,0,0,1-8.25-1.85,19.23,19.23,0,0,1-1.85-8.26V318.55a19.44,19.44,0,0,1,19.44-19.44H546.19a19.3,19.3,0,0,1,8.26,1.84A19.24,19.24,0,0,1,556.3,309.22Z",
    transform: "translate(-57.17)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M150.56,388.54s-33.79,57.12-29.44,78.87,102.65,13.92,102.65,13.92V429.12H202.92l10.22-12.18Z",
    transform: "translate(-57.17)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M627.3,388.54s29,64.08,29.85,77.13-5.78,18.4-32.47,21.82-68.38,0-68.38,0V423l14.51-.87-6.09-5.22Z",
    transform: "translate(-57.17)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M352.76,233.84s-.94,22.09,17.72,36,40,.45,45.19-8.69,12.9-31.36,12.9-31.36Z",
    transform: "translate(-57.17)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M313,143s6.64,84.82,57.49,100.07S464,204.72,468.32,143s-36-117.69-90.2-106.26S305.61,105.73,313,143Z",
    transform: "translate(-57.17)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M491.19,100.44c1.19,4.42,0,9.1-1.44,13.44a125,125,0,0,1-23.82,42.19c.28-1.7.52-3.42.71-5.13a111.57,111.57,0,0,0-2.79-40.61c-7.66-3.33-15.76,6-24,4.55-7.34-1.25-10.71-10-17.2-13.69s-15-1.29-21.41,2.61-12.13,9.23-19.17,11.92c-16.12,6.13-33.62-3.14-48.36-12.1h0l-2.85,10.07c-.29,0-.58,0-.86,0l-1.75.07a15.27,15.27,0,0,0-13.92,10.62c-3.23,10-1.36,18.54.25,30.72.12.9.77,5,1.07,5.88-10-16.38-20.27-39-16-57.66a88.46,88.46,0,0,0,2-9c.51-4.25-.2-8.54-.45-12.81-.61-10.32,1.86-21.39,9.27-28.61,17.59-17.1,32-40.45,55.25-48.29a91.14,91.14,0,0,1,71.32,6c11,5.9,20.59,14,30.12,22C474.42,38.76,481.75,45,486.8,53s7.59,18.11,4.37,27c-1.3,3.6-3.53,7.08-3.27,10.89C488.13,94.22,490.3,97.16,491.19,100.44Z",
    transform: "translate(-57.17)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M476.77 131.33c-2.91 6.73-5.95 13.64-10.13 19.61a111.57 111.57 0 00-2.79-40.61c-7.66-3.33-15.76 6-24 4.55-7.34-1.25-10.71-10-17.2-13.69s-15-1.29-21.41 2.61-12.13 9.23-19.17 11.92c-16 6.09-33.39-3-48.06-11.92-.73-6.49 13.61-12.45 37.48-3.17 19.58 7.62 37-27.84 62.2-18.17 2.87 1.11 4.4 4.46 7.27 5.59 4 1.56 8.39.32 12.61-.28s9.28-.11 11.53 3.52c1.72 2.78 1.11 6.37 1.89 9.55s4.76 6.13 7.09 3.84a68.71 68.71 0 01.81 15.16 13.91 13.91 0 015.55-4.26C481.15 121 478.94 126.32 476.77 131.33zM318.43 114.18c-5.94 12.44-6.32 33.53-2.76 46.83-2.65-6.48-7.94-19-9.5-25.87-1.34-5.83-2.11-12.5 1.42-17.34a17.27 17.27 0 002.43-3.48 14.29 14.29 0 00.63-3.2c.55-3.53 3.1-7.32 6.67-7.14a8.63 8.63 0 014 1.58c2.15 1.37 8.32 4.93 8.71 8.16z",
    opacity: 0.24,
    transform: "translate(-57.17)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M555.94,494.3s-1,10.42-8.42,16a.91.91,0,0,1-.16.11,17.33,17.33,0,0,1-9.81,3.29c-.35,0-.69,0-1.06,0H242.84a19.41,19.41,0,0,1-8.26-1.85,19.37,19.37,0,0,1-1.84-8.26V406.42Z",
    transform: "translate(-57.17)",
    style: {
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M263,511H235l-1.85-26.75V318.55a19.44,19.44,0,0,1,19.44-19.44h71.33S249,299.37,245.55,316s0,183.6,0,183.6S242.08,508.4,263,511Z",
    opacity: 0.24,
    transform: "translate(-57.17)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingWithLaptop);
export default __webpack_public_path__ + "static/media/working-with-laptop.78a847f13f98e43ef85b849840064990.svg";
export { ForwardRef as ReactComponent };